// extracted by mini-css-extract-plugin
export default {"DimensionsFeature":"vw_a bhj_b bhj_wb"};